import { type ParkingSpotRequirementProfile } from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const ParkingSpotRequirementProfileItem: RelationFieldProps<ParkingSpotRequirementProfile> =
  {
    filters: [],
    renderItem: (item) => ({
      title: item?.name ?? '',
      descriptionItems: <></>,
    }),
  };
